export default "__VITE_ASSET__CWzdfVzG__"